import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKatacodaComponent } from './simple-icons-katacoda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKatacodaComponent ],
    exports:      [ SimpleIconsKatacodaComponent ],
    bootstrap:    []
})
export class SimpleIconsKatacodaModule {}
